import axiosInstance from './config/api';

export interface ManualCallbackResponse {
    callId: string;
    livekitCreds: {
        PartyID: string;
        Room: string;
        URL: string;
        Token: string;
        CallID: string;
    };
}

export const postManualCallback = (callId: string) => {
    return axiosInstance.post<ManualCallbackResponse>(`/calldispatch/manual/${callId}`).then((res) => res.data);
};
